// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","slider":"slider_slider__po65p","imgWrapper":"slider_imgWrapper__e5p95","image":"slider_image__85JIz"};